import './OrdersList.scss';

import { FC } from 'react';
import { IOrder } from "../../../helpers/types";

import Placeholder from "../../atoms/Placeholder/Placeholder";
import Pagination from "../../atoms/Pagination/Pagination";
import { getTimeDate } from "../../../helpers/functions";
import OrderItem from "../OrderItem/OrderItem";

interface IOrdersList {
    isCheck?: boolean;
    items: IOrder[];
    onChangePagination?: (value: number) => void;
    totalCount?: number;
    currentPage?: number;
    perPage?: number;
    pageUrl?: string;
    onCheckSelect?: (name: string, checked: boolean) => void;
    onDelete?: (id: number) => void;
    isDelete?: boolean;
}

const OrdersList: FC<IOrdersList> = ({
                                         isDelete = false,
                                         onDelete = () => {},
                                         isCheck = true,
                                         onCheckSelect = () => {},
                                         items,
                                         onChangePagination = () => {},
                                         totalCount = 0,
                                         perPage = 10,
                                         currentPage = 1,
                                         pageUrl = ''
                                     }) => {
    return (
        <div className={'order-list'}>
            {items && items.length > 0 ?
                items.slice(0, perPage).map(item => {
                    let tg_user_parsed: any = {};
                    try {
                        tg_user_parsed = item?.tg_user ? JSON.parse(item.tg_user) : {};
                    } catch (e) {
                    }

                    return (
                        <div key={item.id} className="order-list__item">
                            <OrderItem
                                {...item}
                                isDelete={isDelete}
                                onDelete={() => onDelete(item.id)}
                                isCheck={isCheck}
                                isSelected={item?.isSelected}
                                phone={item?.phone}
                                id={item.id}
                                tg_user={`${tg_user_parsed?.username ? tg_user_parsed?.username : ''}`}
                                onSelect={(e: any) => onCheckSelect(item.tg_user as string, e)}
                                status={item.status ? Number(item.status) : 4}
                                date={getTimeDate(item.createdAt)}
                            />
                        </div>
                    );
                })
                : <Placeholder header={'Ups!'} message={'Orders not found'} />
            }
            {totalCount > 0 &&
                <div className="order-list__pagination">
                    <Pagination
                        pageUrl={pageUrl}
                        currentPage={Number(currentPage)}
                        totalItems={totalCount}
                        itemsPerPage={perPage}
                        onPageChange={onChangePagination}
                    />
                </div>
            }
        </div>
    );
};

export default OrdersList;